var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Musafir Orders")]),_c('GChart',{attrs:{"type":"BarChart","data":_vm.quantityData,"options":_vm.quantityOptions}}),_c('GChart',{attrs:{"type":"BarChart","data":_vm.salesData,"options":_vm.salesOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }